import { Injectable } from '@angular/core';
import { environment } from '../../../environments/local/environment';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class BaseApiService {
  // this is env dependent and uses fileReplacement based on configuration in angular.json
  protected apiUrl = environment.host;

  constructor(protected auth: AuthService) {}

  get authHeader(): { headers: { [k: string]: string } } {
    return {
      headers: {
        Authorization: `Bearer ${this.auth.accessToken}`,
      },
    };
  }
}
